import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CategoryEntity } from './category.entity';
import { ItemEntity } from './item.entity';

@Index('fk_category__id', ['fkCategoryId'], {})
@Index('fk_item__id', ['fkItemId'], {})
@Index(
	'item_category_itemExternalId_deletedDate',
	['itemExternalId', 'deletedDate'],
	{},
)
@Entity('item_category')
export class ItemCategoryEntity extends BaseEntity {
	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('int', { name: 'fk_category__id', unsigned: true })
	public fkCategoryId!: number;

	@Column('varchar', { name: 'itemExternalId', nullable: true, length: 64 })
	public itemExternalId!: string | null;

	@ManyToOne(() => ItemEntity, (item) => item.itemCategories, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(() => CategoryEntity, (category) => category.itemCategories, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_category__id', referencedColumnName: 'id' }])
	public category!: CategoryEntity;
}
